import React from 'react';
import { WebsiteDesignProps } from './types';
import { Palette, Layers, Image as ImageIcon } from 'lucide-react';
import { Button } from "@/components/ui/button";

const CreativeStudio: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Design Studio";

    return (
        <div className="bg-neutral-900 text-white min-h-screen font-sans">
            <nav className="p-8 flex justify-between items-center sticky top-0 bg-neutral-900/90 backdrop-blur z-50">
                <div className="text-2xl font-bold tracking-tight">
                    {schoolName}<span className="text-lime-400">.</span>
                </div>
                <div className="flex gap-4">
                    <Button variant="ghost" className="text-white hover:text-lime-400">Work</Button>
                    <Button variant="ghost" className="text-white hover:text-lime-400">About</Button>
                    <Button className="bg-lime-400 text-black hover:bg-lime-500 font-bold rounded-full">
                        Let's Talk
                    </Button>
                </div>
            </nav>

            <header className="container mx-auto px-8 py-20">
                <h1 className="text-6xl md:text-9xl font-bold leading-none tracking-tighter mb-12">
                    Design <br/> <span className="text-lime-400">Matters.</span>
                </h1>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                    <p className="text-xl text-neutral-400 leading-relaxed max-w-md">
                        We teach the principles of visual communication, user experience, and brand identity to the next generation of creative directors.
                    </p>
                    <div className="flex items-end justify-start md:justify-end">
                        <div className="flex gap-4">
                            <div className="w-12 h-12 rounded-full bg-neutral-800 border border-neutral-700 flex items-center justify-center">
                                <Palette className="text-lime-400" size={20} />
                            </div>
                            <div className="w-12 h-12 rounded-full bg-neutral-800 border border-neutral-700 flex items-center justify-center">
                                <Layers className="text-lime-400" size={20} />
                            </div>
                            <div className="w-12 h-12 rounded-full bg-neutral-800 border border-neutral-700 flex items-center justify-center">
                                <ImageIcon className="text-lime-400" size={20} />
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <section className="container mx-auto px-8 pb-20">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div className="bg-neutral-800 aspect-square rounded-2xl p-8 hover:bg-neutral-700 transition-colors cursor-pointer group">
                         <div className="h-full flex flex-col justify-between">
                             <div className="w-12 h-12 bg-white rounded-full group-hover:scale-110 transition-transform"></div>
                             <h3 className="text-3xl font-bold">Graphic Design</h3>
                         </div>
                    </div>
                    <div className="bg-neutral-800 aspect-square rounded-2xl p-8 hover:bg-neutral-700 transition-colors cursor-pointer group mt-0 md:mt-20">
                         <div className="h-full flex flex-col justify-between">
                             <div className="w-12 h-12 bg-lime-400 rounded-full group-hover:scale-110 transition-transform"></div>
                             <h3 className="text-3xl font-bold">UI/UX</h3>
                         </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CreativeStudio;
